export const HOW_TO_SHARE_MODAL = 'HOW_TO_SHARE_MODAL';
